import AdminStartHub from './components/start-hub/AdminStartHub.vue';

export default function registerAdminPanelStartHubVueComponents(app) {
    app.component('admin-start-hub', AdminStartHub);
}
